module.exports = __webpack_public_path__ + "img/activity.eb78e7f3.jpg";